export default __webpack_public_path__ + "b46093b335f26a7c6e76e12476b6cbab.svg";